
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/zoomd",
      function () {
        return require("private-next-pages/destinations/zoomd.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/zoomd"])
      });
    }
  